import { Component, OnInit } from "@angular/core";
import { take } from "rxjs/operators";
import { Router } from "@angular/router";
import { Store, select } from "@ngrx/store";
import { ReturnOrderService } from "../../../shared/services/return-order/return-order.service";
import { SpinnerService } from "../../../shared/services/spinner.service";
import { CopyHelpers } from "../../../shared/helpers/copy.helpers";
import { addItemToReturnOrderAction } from "../../../store/actions/order.actions";
import { clientConfig } from "../../../shared/constant/app.constant";

@Component({
  selector: "app-cancelorder",
  templateUrl: "./cancelorder.component.html",
  styleUrls: ["./cancelorder.component.scss"],
})
export class CancelorderComponent implements OnInit {
  returnOrder: any;
  orderData: any;
  pickupDateString: any;
  pickupDateAndTime: any;
  errorinfo = {
    title: "cancelOrderValidationFailedSubject",
    message: "cancelOrderValidationFailedBody",
  };
  isError = false;
  routeUrl: any;
  pickupTimeEnd: any;

  constructor(
    private returnOrderSerice: ReturnOrderService,
    private spinnerService: SpinnerService,
    private router: Router,
    private store: Store<AppState>
  ) {
    this.store
      .pipe(select("orderData"))
      .pipe(take(1))
      .subscribe((o) => {
        this.orderData = o;
      });

    this.store.pipe(select("returnOrder")).subscribe((items) => {
      this.returnOrder = CopyHelpers.deepCopy(items);
    });

    if (
      this.orderData.cancelOrderExpiry &&
      new Date(new Date(this.orderData.cancelOrderExpiry) + " UTC").getTime() > new Date(new Date() + " UTC").getTime()
    ) {
      this.returnOrder.orderLines.forEach((orderLine) => {
        if (
          (this.returnOrder.items.findIndex((x) => x.itemNumber === orderLine.itemNumber) === -1 ||
            this.returnOrder.items.findIndex((x) => x.itemName === orderLine.itemName) === -1) &&
          orderLine.returnable
        ) {
          const newItem = CopyHelpers.deepCopy(orderLine);

          this.pickupDateString = newItem.pickupDate;
          this.pickupDateAndTime = this.pickupDateString.split('T');

          newItem.returnQuantity = newItem.quantityToReturn;
          this.store.dispatch(addItemToReturnOrderAction({ payload: { item: newItem } }));
        }
      });

      this.pickupTimeEnd = clientConfig.SHIPPING_OPTIONS.collection[0].collectionTimeEnd;
    } else {
      this.isError = !this.isError;
    }
  }

  ngOnInit(): void {}

  cancelOrder() {
    this.spinnerService.show();

    this.returnOrderSerice.cancelOrder(clientConfig.MERCHANT_ID, clientConfig.EXTERNAL_ID, "Return").subscribe(
      (res: any) => {
        this.spinnerService.hide();
        if (res.success) {
          this.router.navigate(["/d/shippingoption"]);
        } else {
          this.isError = !this.isError;
          this.errorinfo.title = "cancelOrderFailedSubject";
          this.errorinfo.message = "cancelOrderFailedBody";
        }
      },
      (err) => {
        this.isError = !this.isError;
        this.errorinfo.title = "cancelOrderFailedSubject";
        this.errorinfo.message = "cancelOrderFailedBody";
        this.spinnerService.hide();
      }
    );
  }
}
